<template>
    <!-- Publish Modal -->
    <base-modal :id="modalId" :loading="modalLoading" :centered="true">
        <template slot="title">
            <span class="icon icon-glyphicons-basic-world-east mr-2"></span>
            <span>Submit For Community Publishing</span>
        </template>
        <template>
            <div v-show="selectedCase.community_published_status == 'none'">
                <p class="mb-0" :id="legalStatementId">
                    All content published on Affinity Community is licensed under
                    <a :href="creativeCommonsLicenseUrl" target="_blank" rel="noopener">Creative Commons
                    Attribution-ShareAlike 4.0 International (CC BY-SA 4.0)</a>. Authors and their associated institutions are always clearly credited for their contributions.
                    All learning experiences are subject to an internal review by our team before they are published.
                </p>
                <div class="form-check mt-3">
                    <input :id="modalId + 'accept'" type="checkbox" class="form-check-input" v-model="userAccepts" />
                    <label class="form-check-label" :for="modalId + 'accept'"> I accept </label>
                </div>
            </div>
            <p v-show="selectedCase.community_published_status == 'in_review'" class="mb-0">
                This learning experience has been submitted for publishing and is currently under review. If you need to get in
                touch with our team about your submission, please
                <a href="mailto:support@affinitylearning.ca?subject=Publishing Inquiry">send us a message</a>.
            </p>
            <p v-show="selectedCase.community_published_status == 'published'" class="mb-0">
                This learning experience is currently published to the community. If you need to get in touch with our team about
                your submission, please
                <a href="mailto:support@affinitylearning.ca?subject=Publishing Inquiry">send us a message</a>.
            </p>
        </template>
        <template slot="footer">
            <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
            <button
                @click="submitPublish()"
                :disabled="modalLoading || !userAccepts || selectedCase.community_published_status == 'in_review'"
                class="btn btn-primary"
                type="button"
                v-show="!(selectedCase.community_published_status == 'published')"
            >
                Submit
            </button>
        </template>
    </base-modal>
</template>

<script>
import BaseModal from "@/components/BaseModal"
import http from "@/axios.js"

export default {
    name: "CommunityPublishModal",
    components: {
        BaseModal,
    },
    props: {
        selectedCase: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            modalLoading: false,
            userAccepts: false,
        }
    },
    computed: {
        modalId() {
            return "publish-modal-" + this._uid
        },
        legalStatementId() {
            return this.modalId + "-legal"
        },
        creativeCommonsLicenseUrl() {
            return this.$store.getters.creativeCommonsLicenseUrl
        },
    },
    methods: {
        open() {
            this.userAccepts = false
            $("#" + this.modalId).modal("show")
        },
        submitPublish() {
            if (!this.userAccepts) {
                return
            }
            let statementText = document.getElementById(this.legalStatementId).innerHTML
            this.modalLoading = true
            let vm = this
            http.post("/api/community/case/" + this.selectedCase.id + "/publish/", {
                userAccepts: this.userAccepts,
                statementText: statementText,
            })
                .then(function () {
                    vm.modalLoading = false
                    $("#" + vm.modalId).modal("hide")
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Learning experience submitted for publishing.",
                        data: {},
                    })
                    vm.userAccepts = false
                    vm.$emit("submitted")
                })
                .finally(function () {
                    vm.modalLoading = false
                })
        },
    },
}
</script>

<style>
</style>